import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import AcademyCategoriesApi from 'libs/api/retailAcademy/academyCategories';

const api = new AcademyCategoriesApi();

const useSingleAcademyCategory = () => {
  const { id: routeId } = useParams();
  const [singleItem, setSingleItem] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!routeId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(routeId);
        const item = data?.academy_category;

        if (!cancelled) {
          setSingleItem(item || {});
        }
      } catch {
        if (!cancelled) {
          setSingleItem({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [routeId]);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleAcademyCategory;
